export default "__VITE_ASSET__BToyiUHP__"